import React, { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { waLink } from "../lib/site";

export default function FloatingWhatsApp() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      href={waLink()}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp"
      aria-label="Falar no WhatsApp"
      className={`fixed bottom-6 right-6 z-50 flex items-center gap-3 transition-all duration-500 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3 pointer-events-none"
      }`}
    >
      <span className="hidden md:inline-block bg-[#05070D]/90 backdrop-blur border border-[#D4AF37]/30 text-white text-xs tracking-[0.16em] uppercase px-4 py-2">
        Fale Conosco
      </span>
      <span className="ag-pulse w-14 h-14 rounded-full bg-[#25D366] flex items-center justify-center shadow-lg hover:bg-[#1ebd5a] transition-colors">
        <MessageCircle size={26} strokeWidth={1.6} className="text-white" />
      </span>
    </a>
  );
}
